// src/sharedPrompts.js
export const sharedPrompts = [
  {
    name: '과세특(기본)',
    description: '과세특을 쓰는 최소 설정, 수행평가(보고서)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '과목별 세부능력 및 특기사항',
      subjectField: '',
      activityContent: '',
      providedMaterials: '학생이 제출한 보고서 제목, 교사의 관찰 평가 키워드',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성, 진로 연관성 등',
      minBytes: 500,
      maxBytes: 1000,
      conditions: `## 작성 순서
1. 제목과 탐구 방법을 작성: 
   - 예시: ~~~을 제목으로 보고서를 제출함.
2. 나머지 내용을 추가`,
      openAIParameters: {
        temperature: 0.8,
        topP: 0.8,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '과세특(화학)',
    description: '화학, 수행평가(자유탐구활동)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1',
      },
      task: '과목별 세부능력 및 특기사항',
      subjectField: '화학',
      activityContent: '자유탐구활동(자료 조사, 논문 분석, 탐구 실험 등)',
      providedMaterials: '학생이 수행한 탐구 방법, 제목 또는 논문 제목, 교사의 관찰 평가 문장, 학생의 자기평가 문장, 발표에 대한 동료평가 문장',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성, 진로 연관성 등',
      minBytes: 500,
      maxBytes: 1500,
      conditions: `## 작성 순서
1. 제목과 탐구 방법을 작성: 
   - 예시: ~~~을 제목으로 조사하여 발표함.
   - 예시: ~~~을 제목으로 실험하여 발표함.
2. 이 주제를 선택한 이유
3. 실제로 학생이 수행한 내용, 장점
4. 이 활동을 통해 배운 점(느낀 점)
5. 나머지 내용을 추가`,
      openAIParameters: {
        temperature: 0.2,
        topP: 0.8,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '과세특(수학)',
    description: '수학, 수행평가(수학과 실생활 탐구, 문제 풀이, 논술)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '과목별 세부능력 및 특기사항',
      subjectField: '수학II',
      activityContent: '문제 풀이, 수학과 실생활 탐구, 논술형 답안 작성',
      providedMaterials: '포트폴리오 등급(상중하), 수리탐구 활동 등급(상중하) 및 분야,  논술형 평가 등급(상중하)',
      includedContent: '학생이 수행한 노력과 완성도, 학생의 탐구한 수리와 실생활과의 관계, 수학적 발전 가능성과 창의성 등 수학과 관련된 사고 방식, 진로 연관성 등',
      minBytes: 300,
      maxBytes: 1800,
      conditions: `문제점은 되도록 언급하지 않되 언급할 시 꼭 보완할 점이나 장점과 같이 언급할 것.
같은 문장은 다시 절대 사용하지 말것.

## 작성 순서
1. 포트폴리오 등급에 따른 노력과 완성도.
  - 예시: 학습 태도 ~~하고 풀이가 ~~해서 학생의 노력과 완성도를 ~~ 함.
  - 등급에 대한 언급은 하지 말 것
  - 포트폴리오라는 단어를 사용하지 말 것
2. 수리탐구 활동을 통해 ~~을 탐구 하였고 진로 및 실생활과 ~~ 연관이 있음을 확인함.
  - 진로 및 관련 내용에 대해 등급에 따른 내용 추가
  - 하 등급인 경우 : 관련 내용 소폭 추가
  - 중 등급인 경우 : 관련 내용 중폭 추가
  - 상 등급인 경우 : 관련 내용 대폭 추가
3. 논술형 풀이를 토대로 학생은 수학적 발전 가능성이 ~~하고 창의력 등 수학적인 재능이 ~~함.
4. 나머지 내용을 추가 (보완할 점 및 장점에 대해 서술)`,
      openAIParameters: {
        temperature: 0.5,
        topP: 0.7,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '과세특(국어)',
    description: '국어, 수행평가(독서, 발표, 논술형 보고서)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '과목별 세부능력 및 특기사항',
      subjectField: '국어',
      activityContent: '독서활동, 발표활동, 논술형 보고서 작성',
      providedMaterials: '학생이 읽은 책 제목, 학생의 진로, 교사의 관찰 평가 문장, 학생의 자기평가 문장, 발표에 대한 평가 문장',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성, 진로 연관성 등',
      minBytes: 1000,
      maxBytes: 1300,
      conditions: `## 작성 순서
1. 고전소설을 읽은 읽은 숫자에 따라:
  - 예시: 고전소설 읽기 시간에 ~~~, ~~~, ~~~, ~~~, ~~~ 등의 작품을 제대로 읽고 독서 일지를 성실하게 작성하여 냄.
  - 예시: 고전소설 읽기 시간에 ~~~, ~~~, ~~~, ~~~, ~~~ 등의 작품을 바른 자세로 읽고 그 일지를 작성하여 제출함.
  - 예시: 고전소설 읽기 시간에 ~~~, ~~~, ~~~, ~~~, ~~~ 등의 작품을 읽고 제 시간 안에 독서 일지를 작성하여 제출함.
2. 고전소설 발표를 잘 했다는 내용 있으면:
  - 예시: 이들 작품 중에 ~~~를 적절한 시간 내에 충분한 성량으로 훌륭하게 발표하여 공동체 역량, 의사소통 역량을 선보임.
3. 발표 중에 학생이 읽은 주제 도서에 대한 내용을 반영:
  - 예시: ~~~라며 읽은 동기를 밝히고 ~~~의 추천 사유를 밝힘. 문학 감상을 자기 표현의 방법으로 정확하게 선보이는 발표를 함.
4. 고전논술에 대한 평가가 있는 경우:
  - 예시: '관동별곡'에서 문학의 미적범주를 찾아내어 잘 정리하였고, '양반전'과 '춘향전' 속에서 한국 문학의 미인 해학과 골계미에 대해 논리적으로 서술함. 삶과 성찰의 삶을 사는데 필수적인 문학적 소양을 잘 보임.
5. 국어부장 단어가 들어가면:
  - 예시: 국어부장으로 활동하며 학습지 학급별 단체방에 공유, 시험범위 전달 등의 활동으로 교과담임교사를 도움.`,
      openAIParameters: {
        temperature: 0.2,
        topP: 0.7,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '과세특(음악)',
    description: '음악, 수행평가(가창, 기악, 작사하여 AI로 작곡하기)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '과목별 세부능력 및 특기사항',
      subjectField: '음악',
      activityContent: '가창(뮤지컬 넘버 부르기), 기악(피아노 혹은 기타 연주하기), 직접 작사하여 AI코스웨어를 활용하여 작곡하기',
      providedMaterials: '가창 및 기악 수행 평가 등급, 수행과제, 창작과제에서 자신이 만든 가사 주제 및 내용',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성 등',
      minBytes: 1000,
      maxBytes: 1300,
      conditions: `학생의 역량에는 학생의 강점, 세부 능력, 가창이나, 기악등의 연주 수행을 할 때 발휘된 강점이나 표현방법 등이 포함된다.
가창수행평가에서는 상,중,하 등급으로 나뉘어져 등급별로 수행에 대한 평가를 할 것이며, 각자 부른 곡은 작은 따옴표로 표기한다.
기악수행평가에서는 상,중,하 등급으로 나뉘어져 등급별로 수행에 대한 평가를 할 것이며, 각자 연주한 곡은 큰 따옴표로 표기한다.
기악수행평가에서 사용한 악기는 기타 혹은 피아노 이다.
모든수행평가에 대한 평가 서술시 아쉬운 부분이나 부정적인 감정이나 느낌은 배제한다.
평가시 등급의 명칭은 생략한다.
단순하게 참여한 과정 기재 서술은 지양한다 학생의 과정이후 변화된 성장 내용, 활동의 학습 참여도와 태도를 서술한다.
학생의 강점이나, 학생이 단점을 극복한 과정을 서술한다.
기악 수행평가와 가창 수행평가 평가 서술 시 강점이나 장점을 구체적으로 서술한다.
가창 수행평가에서 '각자 연주한 곡' 그리고 평가의 내용을 서술한다.(예:가창 수행평가에서 '연주곡'을 불러)
기악 수행평가에서 '각자 연주한 악기와 곡' 그리고 평가의 내용을 서술한다.
창작 할동에서는 AI코스웨어를 활용하여 음악만들기 활동을 하였으며, 각자의 아이디어와 창작이유를 더해 곡을 작곡하였다.
창작 활동에서의 아이디어는 <,>를 활용하여 나타낸다.
창작 활동을 서술 할때는 <,>는 생략하여 서술한다.
서술을 할때는 따옴표는 생략하고 서술한다. 쉼표, 마침표만 가능하다.`,
      openAIParameters: {
        temperature: 0.2,
        topP: 0.7,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '창체(기본)',
    description: '진로활동',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '창의적 체험활동 특기사항',
      subjectField: '진로활동',
      activityContent: '활동 참여',
      providedMaterials: '학생이 수행한 활동, 교사의 관찰 평가 문장',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성, 진로 연관성 등',
      minBytes: 500,
      maxBytes: 1500,
      conditions: `## 작성 순서
1. 진로탐색보고서를 작성함.
2. 활동과 역량을 작성:
  - 예시: ~~~에 참여하여 ~~~함.
  - 예시: ~~~에서 ~~~함.
3. 실제로 학생이 수행한 내용, 장점, 가능성
4. 나머지 내용을 추가`,
      openAIParameters: {
        temperature: 0.8,
        topP: 0.8,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '창체(학생회)',
    description: '자율활동, 학생회자치회 활동',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '창의적 체험활동 특기사항',
      subjectField: '자율활동',
      activityContent: '',
      providedMaterials: '학생자치회 활동 내용, 활동하면서 느낀점, 인상에 남은 기억나는 활동',
      includedContent: '학생이 수행한 노력과 활동, 학생의 장점과 발전 가능성 등',
      minBytes: 500,
      maxBytes: 700,
      conditions: `제36대 학생자치회 (직함) 으로서 ~ 교내 행사 질서 지도 및 아침 등교 캠페인, 교육구성원 대토론회, 학교 축제 기획 및 진행 등 다양한 학생자치활동을 기획하고 참여함. ~ 로 시작한다.
평가를 서술할때는 ( )를 생략한다.`,
      openAIParameters: {
        temperature: 0.8,
        topP: 0.5,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '창체(동아리)',
    description: '동아리 활동, 연극 동아리',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '창의적 체험활동 특기사항',
      subjectField: '동아리 활동(연극 동아리)',
      activityContent: '낭독 공연',
      providedMaterials: '학생이 제출한 자기평가(동아리에 가입한 이유, 낭독 공연 작품, 낭독 공연에서 맡은 일, 담당한 배역과 인물 분석, 동아리 활동과 낭독 공연을 통해 배운 점, 동아리활동의 아쉬운 점과 어려운점), 교사의 관찰평가 문장',
      includedContent: '학생의 연극 관련 자질과 수행한 노력과 활동, 장점과 발전 가능성, 흥미, 적성, 진로 연관성 등',
      minBytes: 700,
      maxBytes: 1000,
      conditions: `## 작품명 작성 형식의 예
'손없는 날(조은주)'
'마르길 기다리며(신윤주)'

# 작성 순서
1. 연극 동아리에 가입한 이유와 진로 관련성(연극과 진로 관련성이 없다면 생략)
2. 참여한 작품과 역할, 배운점
3. 나머지 내용을 추가`,
      openAIParameters: {
        temperature: 0.2,
        topP: 0.5,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
  {
    name: '행특(기본)',
    description: '행동특성 및 종합의견, 협업과 소통능력(학급회의)',
    settings: {
      model: {
        text: 'gpt',
        value: 'gpt-4.1'
      },
      task: '행동특성 및 종합의견',
      subjectField: '협업과 소통능력',
      activityContent: '학급회의',
      providedMaterials: '학급회의와 학급 내에서 수행한 내용',
      includedContent: '',
      minBytes: 500,
      maxBytes: 1000,
      conditions: '실례를 들어서 작성',
      openAIParameters: {
        temperature: 0.8,
        topP: 0.5,
        frequencyPenalty: 0.8,
        presencePenalty: 1.3,
        seed: 0,
        randomSeed: true,
      },
    },
  },
];
